import React from 'react';

import PropTypes from 'prop-types';

import { Text } from '@asteria/component-core/typography';

import { ListCell, ListItem } from '@asteria/component-list';

import { Translation } from '@asteria/language';

import RowClient from './row-client';
import RowTags from './row-tags';

import './styles.scss';

/**
 * @typedef { import('./types').Props } Props
 * @typedef { import('./types').ChildrenProps } ChildrenProps
 */

/** @type { React.FC<ChildrenProps & { section: unknown, object: unknown }> } */
const SectionRow = React.memo(function SectionRow(props) {
	const { object, links, query } = props;

	const loading = query?.isFetching;

	return (
		<ListItem>
			<ListCell>
				<Translation
					translationKey={[
						'transaction.details',
						`transaction.details.${object.key}`,
						`transaction.details.${object.key}.${query?.data?.status}`,
					]}
					data={{
						value: object.value,
						item: query?.data,
						...links,
						bank: links.bankTransaction,
					}}
					Component={Text}
				/>
			</ListCell>
			<ListCell>
				{object.key === 'client' ? (
					<RowClient {...props} />
				) : object.key === 'tags' ? (
					<RowTags {...props} />
				) : (
					<Translation
						translationKey={[
							'transaction.details.value',
							`transaction.details.${object.key}.value`,
							`transaction.details.${object.key}.${query?.data?.status}.value`,
							`transaction.details.${object.key}.${object.value}.value`,
							`transaction.details.${object.key}.${query?.data?.status}.${object.value}.value`,
						]}
						defaultText="{{ value }}"
						data={{
							value: object.value,
							item: query?.data,
							...links,
							bank: links.bankTransaction,
						}}
						Component={Text}
						loading={loading}
					/>
				)}
			</ListCell>
		</ListItem>
	);
});

SectionRow.propTypes = {
	object: PropTypes.object,
	query: PropTypes.object,
	links: PropTypes.object,
};

export default SectionRow;
